import { Component, signal } from '@angular/core';

import { OneColumnComponent } from '../../../shared/layout/one-column/one-column.component';

@Component({
    selector: 'lib-not-found',
    imports: [OneColumnComponent],
    template: `
    <lib-one-column>
      <h2>404 NotFound</h2>
      <p class="intro">The resource you are looking for can not be found.</p>
    </lib-one-column>
  `,
    styles: []
})
export class NotFoundComponent {}
